import { render, staticRenderFns } from "./EstimatedNumberOfFramesField.vue?vue&type=template&id=797bc59a"
import script from "./EstimatedNumberOfFramesField.vue?vue&type=script&lang=js"
export * from "./EstimatedNumberOfFramesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports